import React, { useEffect, useMemo } from 'react'

import { useInstData } from 'tyan/public/hooks'

const Need2KnowDlg = ({ content, delay, value, onAgree, onDisagree, onClose, showBody: Body }) => {
	const { me, setState, me: { state: { remain } } } = useInstData(null, useMemo(() => ({ state: { remain: value ? 0 : delay, initValuesBasic: { content } } }), []))


	const handleAgree = () => (onAgree(), onClose())
	const handleDisagree = () => (onDisagree(), onClose())

	const controls = useMemo(() => {
		return [
			{ _button: `同意${remain > 0 ? `(${remain})` : ''}`, name: 'Agree', handler: handleAgree, disabled: remain > 0 },
			{ _button: '不同意', name: 'Disagree', handler: handleDisagree },
		]
	}, [remain])

	useEffect(() => {
		const countDown = () => {
			setState(prev => ({ remain: prev.remain - 1 }))
		}

		!value && remain > 0 && setTimeout(countDown, 1000)
	}, [remain, value])

	const fieldsetBasic = useMemo(() => [
		{ _html: '', name: 'content' },
	], [])

	return <Body data={me}
		controls={controls}
		fieldsets={
			[
				{ title: '', name: 'Basic', _fieldset: fieldsetBasic/* , docked: 'top' */ },
			]}
	/>

}

export default Need2KnowDlg